import WelcomeVideoModal from './components/WelcomeVideoModal/WelcomeVideoModal';
import BusinessTypeModal from './components/BusinessTypeModal/BusinessTypeModal';
import SetupChecklist from './components/SetupChecklist/SetupChecklist';
import TourEngine from './components/TourEngine/TourEngine';
import CelebrationModal from './components/CelebrationModal/CelebrationModal';
import OnboardingButton from './components/OnboardingButton/OnboardingButton';

const OnboardingModule = () => {
  return (
    <>
      <WelcomeVideoModal />
      <BusinessTypeModal />
      <SetupChecklist />
      <TourEngine />
      <CelebrationModal />
      <OnboardingButton />
    </>
  );
};

export default OnboardingModule;
